import Mustache from 'mustache';
import Pristine from 'pristinejs';
import TailSelect from "tail.select.js";
export default class RegistrationForm {
	constructor() {
		this.form = document.querySelector( '[data-registration-form="element"]' );

		if ( null === this.form ) {
			return;
		}

		this.init();
	}

	init() {
		this.selectedTickets = [];
		this.changedEvent = new Event( 'changed' );
		
		this.select = this.form.querySelector( '[data-registration-form="select-ticket"]');
		this.add = this.form.querySelector( '[data-registration-form="add-ticket"]');
		this.template = this.form.querySelector( '[data-registration-form="template"]');
		this.tickets = this.form.querySelector( '[data-registration-form="tickets"]');
		this.totals = this.form.querySelector( '[data-registration-form="totals"]');
		this.submit = this.form.querySelector( '[data-registration-form="submit"]');

		this.countries = this.form.querySelector( '[data-countries]');

		this.validator = this.createValidator();
		this.submit.disabled = true;
		this.submit.innerHTML = this.submit.getAttribute( 'data-label-disabled');

		TailSelect(this.select, {});
		TailSelect(this.countries);

		this.form.addEventListener( 'submit', (e) => {
			e.preventDefault();

			let valid = this.validator.validate( this.form.querySelectorAll( '.registration-validate input' ) );

			if ( valid === false ) {
				return;
			}
			
			this.submitForm();
		} );

		this.form.addEventListener( 'changed', (e) => {
			this.recalculateTotals();
			this.validator.reset();

			if ( this.selectedTickets.length < 1 ) {
				this.submit.disabled = true;
				this.submit.innerHTML = this.submit.getAttribute( 'data-label-disabled');
			} else {
				this.submit.disabled = false;
				this.submit.innerHTML = this.submit.getAttribute( 'data-label-enabled');
			}
		} );
		
		this.add.addEventListener( 'click', (e) => {
			e.preventDefault();

			let option = this.select.options[this.select.selectedIndex];

			if ( option.value === '' ) {
				return false;
			}

			let name = option.getAttribute( 'data-name' ),
			people = option.getAttribute( 'data-people' );

			this.selectedTickets.push( option.value );

			let rendered = Mustache.render( this.template.innerHTML, {
				name: name,
				count: this.selectedTickets.length - 1,
				id: option.value,
				loop: () => {
					return (text, render) => {
						let loopTemplate = '';

						for (let index = 0; index < people; index++) {
							loopTemplate += Mustache.render( text, {
								count: this.selectedTickets.length - 1,
								index: index
							} );
						}

						return loopTemplate;
					}
				} 
			} );

			rendered = this.htmlToElement( rendered );
			this.tickets.append(rendered);
			this.validator = this.createValidator();

			this.form.dispatchEvent( this.changedEvent );
		} );

		this.tickets.addEventListener( 'click', (e) => {
			let target = e.target;

			if ( target.matches( '[data-registration-form="remove"]' ) ) {
				let ticket = target.closest( '[data-registration-form="ticket"]' ),
				index = ticket.getAttribute( 'data-ticket-index' );

				this.selectedTickets.splice( index, 1 );

				ticket.remove();
				this.form.dispatchEvent( this.changedEvent );
			}
		} );

		document.addEventListener( 'keyup', ( e ) => {
			if ( e.key === 'F1' ) {
				this.testFill();
			}
		} );
	}

	createValidator() {
		let validator = new Pristine( this.form, {
			classTo: 'registration-validate',
			errorTextParent: 'registration-validate',
		} );

		return validator;
	}

	recalculateTotals() {
		let data = new FormData();
		data.append( 'action', 'registration_totals' );
		data.append( 'security', themeVars.registration.registration_totals_nonce );
		data.append( 'event_id', this.form.getAttribute( 'data-event' ) );
		data.append( 'tickets', this.selectedTickets );

		let request = new XMLHttpRequest();
		request.open( 'POST', themeVars.ajax_url, true );
		request.send( data );

		request.onreadystatechange = () => {
			if ( request.readyState === 4 && request.status === 200 ) {
				let response = JSON.parse( request.responseText );

				if ( response.success === true ) {
					this.totals.innerHTML = response.data.html;
				}
			}
		}
	}

	submitForm() {
		let data = new FormData( this.form );
		data.append( 'action', 'submit_registration' );
		data.append( 'security', themeVars.registration.submit_registration_nonce );
		data.append( 'event_id', this.form.getAttribute( 'data-event' ) );

		let request = new XMLHttpRequest();
		request.open( 'POST', themeVars.ajax_url, true );
		request.send( data );

		request.onreadystatechange = () => {
			if ( request.readyState === 4 && request.status === 200 ) {
				let response = JSON.parse( request.responseText );

				if ( response.success === true ) {
					setTimeout( () => {
						window.location.replace( response.data.redirect );
					}, 500 );
				}
			}
		}
	}
	
	htmlToElement( html ) {
		var template = document.createElement('template');
		html = html.trim(); // Never return a text node of whitespace as the result
		template.innerHTML = html;
		return template.content.firstChild;
	}

	testFill() {
		let testData = {
			'firstname' : [ 'Evžen', 'Jindra' ],
			'lastname' : [ 'Kopírka', 'Hujer' ],
			'phone' : [ '+420777000777' ],
			'email' : [ 'dev@bicepsdigital.com' ],
			'company' : [ 'bicepsdigital' ],
			'street' : [ 'Římská 12' ],
			'postcode' : [ '12000' ],
			'city' : [ 'Praha' ],
			'country' : [ 'Czech republic' ],
		}

		for ( let key in testData ) {
			let data   = testData[ key ];
			let random = data[Math.floor(Math.random() * data.length)];
 			let inputs = this.form.querySelectorAll( 'input[name*="' + key + '"]' );

			inputs.forEach( ( input ) => {
				input.value = random;
			} );
		}
	}
}
